module.exports = __webpack_public_path__ + "static/mapIcon4-092a687900825aee34490e4d0c700105.png";